import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { breakpoint, getColor } from '../../shared/theme'
import Heading from '../../elements/typography/sectionHeading'
import ContentContainer from '../contentContainer'
import BackgroundImage from '../backgroundImage'
import NavigationArrow from '../../elements/navigationArrow'
import { SectionsButtonLink } from '../../elements/sectionsButtonLink'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import prevArrow from '../../assets/images/slider-arrow-left.png'
import nextArrow from '../../assets/images/slider-arrow-right.png'
import { getImage } from '../../utils/getData'

const SectionWrapper = styled.section`
	padding: 54px 0 0;
	background-color: ${getColor('black')};

	@media ${breakpoint('tablet')} {
		padding: 75px 0 0;
	}

	@media ${breakpoint('laptop')} {
		padding: 102px 0 0;
	}
`

const SectionContainer = styled.div`
	/* max-width: 1440px; */
	max-width: 1600px;
	width: 100%;
	margin: 0 auto;
`

const SectionHeader = styled.div`
	margin-bottom: 28px;
	color: ${getColor('white')};

	@media ${breakpoint('tablet')} {
		margin-bottom: 31px;
		/* color: ${getColor('black')}; */
	}
`

const SectionBody = styled.div`
	/* max-width: 1440px; */
	max-width: 1600px;
	margin: auto;
	overflow: hidden;
`

const SliderContainer = styled.div`
	margin: 10px -5px 0px;

	& .slick-list {
		margin: 0 -7px;
		padding: 0 20% 0 0;
		& .slick-slide > div {
			padding: 0 5px;
		}
	}
`

const Slide = styled.div`
	width: 276px;
	aspect-ratio: 1;
	cursor: pointer;
	background: url(${(props) => props.imageSrc}) no-repeat center/cover;
`

const SlideInner = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 75%;
	margin: 0 auto;
`

const SlideTitle = styled.h4`
	font-size: 12px;
	color: ${getColor('white')};
	font-weight: 700;
	margin-bottom: 0px;
	text-align: center;
	text-transform: uppercase;

	@media ${breakpoint('mobile')} {
		font-size: 18px;
	}

	@media ${breakpoint('tablet')} {
		font-size: 25px;
	}
`

const ActiveSliderWrapper = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: 3;
`

const ActiveSlide = styled.div`
	width: 100%;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	display: ${(props) => (props.isActive ? 'flex' : 'none')};

	@media ${breakpoint('tablet')} {
		display: 'flex';
		opacity: ${(props) => (props.isActive ? 1 : 0)};
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		justify-content: center;
		align-items: center;
		margin-bottom: 0;
	}
`

const ActiveSlideInner = styled.div`
	max-width: 1190px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
`

const SliderInnerContent = styled.div`
	text-align: left;
	width: 44.37%;
	margin-right: 6%;

	@media ${breakpoint('laptop')} {
		margin-right: 0;
	}
`

const ActiveSlideTitle = styled.h4`
	font-size: 20.5px;
	display: inline-block;
	font-weight: 300;
	color: ${getColor('white')};
	background-color: rgba(0, 0, 0, 0.3);
	margin-bottom: 18px;

	@media ${breakpoint('tablet')} {
		font-size: 30px;
		font-weight: 700;
		margin-bottom: 30px;
	}

	@media ${breakpoint('laptop')} {
		font-size: 40px;
		font-weight: 800;
		margin-bottom: 50px;
	}
`

const SlideCopy = styled.p`
	margin: 0;
	font-size: 14.8px;
	line-height: 1.444;
	font-weight: 300;
	width: 88%;
	color: ${getColor('white')};
	background-color: rgba(0, 0, 0, 0.3);
	display: inline;
	padding: 2px 0;

	@media ${breakpoint('tablet')} {
		font-size: 16px;
		width: 100%;
	}

	@media ${breakpoint('laptop')} {
		font-size: 18px;
	}
`

const ImageWrapper = styled.div`
	width: 100%;
	aspect-ratio: 1.015;

	@media ${breakpoint('tablet')} {
		aspect-ratio: 3;
	}
`

const ActiveSlideTablet = styled.div`
	width: 100vw;
	aspect-ratio: 1.19;
`

const ActiveCopyWrapperTablet = styled.div`
	background-color: ${getColor('black')};
	padding: 30px 30px 60px;

	@media ${breakpoint('tablet')} {
		display: none;
	}
`

const ActiveWrapperTablet = styled.div`
	width: 100%;
	height: fit-content;
`

const ButtonWrapper = styled.div`
	margin-top: 28px;
	width: 54%;
`

const NextArrow = (props) => {
	const { className, style, onClick } = props
	return (
		<NavigationArrow
			className={className}
			style={{ ...style, right: '3%' }}
			onClick={onClick}
			src={nextArrow}
			left={false}
		/>
	)
}

const PrevArrow = (props) => {
	const { className, style, onClick } = props
	return (
		<NavigationArrow
			className={className}
			style={{ ...style, left: '3%' }}
			onClick={onClick}
			src={prevArrow}
			left={true}
		/>
	)
}

const slickSettings = {
	infinite: false,
	speed: 500,
	slidesToShow: 6,
	slidesToScroll: 1,
	swipeToSlide: true,
	initialSlide: 0.5,
	nextArrow: <NextArrow />,
	prevArrow: <PrevArrow />,
	responsive: [
		{
			breakpoint: 889,
			settings: {
				infinite: false,
				speed: 500,
				slidesToShow: 3,
				slidesToScroll: 1,
				swipeToSlide: true,
				initialSlide: 1,
			},
		},
		{
			breakpoint: 1250,
			settings: {
				infinite: false,
				speed: 500,
				slidesToShow: 5,
				slidesToScroll: 1,
				swipeToSlide: true,
				initialSlide: 1.5,
			},
		},
	],
}

export const ShowcaseSlider = ({ heading, brands }) => {
	if (!brands?.length) {
		return null
	}

	const [isTabletView, setIsTabletView] = useState()
	const [activeIndex, setActiveIndex] = useState(0)
	const ActiveContainerRef = useRef()
	const ActiveCopyWrapperRef = useRef()

	const [paramValue, setParamValue] = useState(null)
	const paramValueUsedRef = useRef(false)

	useEffect(() => {
		const { href } = window.location

		const index = href.indexOf('?')

		if (index !== -1) {
			const searchParams = href.substring(index + 1)

			setParamValue(searchParams)

			const sliderContainer = document.getElementById('showcaseSlider')

			sliderContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
		}
	}, [])

	const fadeOutIn = () => {
		if (ActiveContainerRef.current) {
			ActiveContainerRef.current.style.transition = 'opacity 0.2s'
			ActiveContainerRef.current.style.opacity = '0'
		}

		if (ActiveCopyWrapperRef.current) {
			ActiveCopyWrapperRef.current.style.transition = 'opacity 0.2s'
			ActiveCopyWrapperRef.current.style.opacity = '0'
		}

		return new Promise((resolve) => {
			setTimeout(() => {
				if (ActiveContainerRef.current) {
					ActiveContainerRef.current.style.opacity = '1'
				}

				if (ActiveCopyWrapperRef.current) {
					ActiveCopyWrapperRef.current.style.opacity = '1'
				}
				resolve()
			}, 200)
		})
	}

	const handleSlideClick = async (index) => {
		await fadeOutIn()
		setActiveIndex(index)
	}

	useEffect(() => {
		setIsTabletView(window.innerWidth <= 889)

		const handleResize = () => {
			setIsTabletView(window.innerWidth <= 889)
		}

		// Add event listener for window resize
		window.addEventListener('resize', handleResize)

		// Clean up the event listener on component unmount
		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	const activeSlide = brands.map((brand, index) => {
		let brandParam = brand.title
			? brand.title.toLowerCase().split(' ').join('-')
			: ''

		if (brandParam === paramValue && !paramValueUsedRef.current) {
			paramValueUsedRef.current = true
			return (
				<ActiveSlide key={index} isActive={brandParam === paramValue}>
					<ImageWrapper>
						<BackgroundImage
							backgroundImage={brand.desktopImage}
							styles={{ justifyContent: 'center', maxWidth: '1600px' }}
						>
							<ActiveSlideInner>
								<SliderInnerContent>
									<ActiveSlideTitle>
										{brand.title && brand.title}
									</ActiveSlideTitle>
									<div>
										<SlideCopy>{brand.copy && brand.copy}</SlideCopy>
									</div>
								</SliderInnerContent>
							</ActiveSlideInner>
						</BackgroundImage>
					</ImageWrapper>
				</ActiveSlide>
			)
		} else if (index === activeIndex) {
			return (
				<ActiveSlide key={index} isActive={index === activeIndex}>
					<ImageWrapper>
						<BackgroundImage
							backgroundImage={brand.desktopImage}
							styles={{ justifyContent: 'center', maxWidth: '100vw' }}
						>
							<ActiveSlideInner>
								<SliderInnerContent>
									<ActiveSlideTitle>
										{brand.title && brand.title}
									</ActiveSlideTitle>
									<div>
										<SlideCopy>{brand.copy && brand.copy}</SlideCopy>
									</div>
								</SliderInnerContent>
							</ActiveSlideInner>
						</BackgroundImage>
					</ImageWrapper>
				</ActiveSlide>
			)
		}
	})

	const activeSlideTablet = brands.map((brand, index) => {
		if (index === activeIndex) {
			return (
				<ActiveSlideTablet key={index}>
					<BackgroundImage backgroundImage={brand.mobileImage} />
				</ActiveSlideTablet>
			)
		}
	})

	const activeSlideCopyTablet = brands.map((brand, index) => {
		if (index === activeIndex) {
			return (
				<ActiveCopyWrapperTablet key={index}>
					<ActiveSlideTitle>{brand.title && brand.title}</ActiveSlideTitle>
					<SlideCopy>{brand.copy && brand.copy}</SlideCopy>
					<ButtonWrapper>
						<SectionsButtonLink
							link={brand.link && brand.link}
							styles={{ width: '100%' }}
						/>
					</ButtonWrapper>
				</ActiveCopyWrapperTablet>
			)
		}
	})

	const slides = brands.map((brand, index) => {
		return (
			<Slide
				key={index}
				imageSrc={getImage(brand.mobileImage)}
				index={index}
				onClick={() => handleSlideClick(index)}
			>
				<SlideInner>
					<SlideTitle>{brand.title && brand.title}</SlideTitle>
				</SlideInner>
			</Slide>
		)
	})

	return (
		<SectionWrapper>
			<SectionContainer>
				<ContentContainer>
					<SectionHeader id="showcaseSlider">
						<Heading>Showcase</Heading>
					</SectionHeader>
				</ContentContainer>
				<ActiveSliderWrapper ref={ActiveContainerRef}>
					{isTabletView ? activeSlideTablet : activeSlide}
				</ActiveSliderWrapper>
				<SectionBody>
					<SliderContainer>
						<Slider {...slickSettings}>{slides}</Slider>
					</SliderContainer>
				</SectionBody>
				<ActiveWrapperTablet ref={ActiveCopyWrapperRef}>
					{activeSlideCopyTablet}
				</ActiveWrapperTablet>
			</SectionContainer>
		</SectionWrapper>
	)
}

export default ShowcaseSlider
